<template>
<div class="mobile_wrap_carousel">
  <!-- <van-swipe :autoplay="7000" :touchable="false" :show-indicators="false">
  <van-swipe-item v-for="(item, index) in pics" :key="index">
    <img v-lazy="item.url" class="pics_each"/> 
    <div class="wrap_titles">
      <div v-if="carouselInx==='0'"  
      :style="item.style" 
      :class="[item.linerow===1?'hellostyle':
      item.linerow===2?'hellostyletwo':
      item.linerow===3?'hellostylethree':
      item.linerow===4?'hellostylefour':
      item.linerow===5?'hellostylefive':
      item.linerow===6?'hellostylesix':
      item.linerow===7?'hellostyleseven':
      item.linerow===8?'hellostyleeight':'',
      Number(carouselIndex)===0 && item.linerow===1?'hellostyleInfi': 
      Number(carouselIndex)===1 && item.linerow===1?'hellostyleOnce':'',
      Number(carouselIndex)===0 && item.linerow===2?'hellostyleInfitwo':
      Number(carouselIndex)===1 && item.linerow===2?'hellostyleOncetwo':'',
       Number(carouselIndex)===0 && item.linerow===3?'hellostyleInfithree':
      Number(carouselIndex)===1 && item.linerow===3?'hellostyleOncethree':'',
       Number(carouselIndex)===0 && item.linerow===4?'hellostyleInfifour':
      Number(carouselIndex)===1 && item.linerow===4?'hellostyleOncefour':'',
      Number(carouselIndex)===0 && item.linerow===5?'hellostyleInfifive':
      Number(carouselIndex)===1 && item.linerow===5?'hellostyleOncefive':'',
      Number(carouselIndex)===0 && item.linerow===6?'hellostyleInfisix':
      Number(carouselIndex)===1 && item.linerow===6?'hellostyleOncesix':'',
       Number(carouselIndex)===0 && item.linerow===7?'hellostyleInfiseven':
      Number(carouselIndex)===1 && item.linerow===7?'hellostyleOnceseven':'',
      Number(carouselIndex)===0 && item.linerow===8?'hellostyleInfieight':
      Number(carouselIndex)===1 && item.linerow===8?'hellostyleOnceeight':'',
]" v-html="item.text"></div>
      <div v-if="carouselInx==='1'" class="hellostylebuss" :style="item.style" :class="Number(carouselIndex)===0?'hellostyleInfi':'hellostyleOnceBuss'" v-html="item.text"></div>
      </div>
  </van-swipe-item>
</van-swipe> -->
  <el-carousel 
  class="wrap_pics" 
  indicator-position="none" 
  arrow="never" 
  :interval="interval"
   ref="carousel" 
   @mouseenter.native="delHandleMouseEnter()">
    <el-carousel-item v-for="(item,index) in pics" 
    :key="index" 
   >
      <img class="pics_each" :src="item.url"/>
      <div class="wrap_titles">
      <div v-if="carouselInx==='0'"  
      :style="item.style" 
      :class="[item.linerow===1?'hellostyle':
      item.linerow===2?'hellostyletwo':
      item.linerow===3?'hellostylethree':
      item.linerow===4?'hellostylefour':
      item.linerow===5?'hellostylefive':
      item.linerow===6?'hellostylesix':
      item.linerow===7?'hellostyleseven':
      item.linerow===8?'hellostyleeight':'',
      Number(carouselIndex)===0 && item.linerow===1?'hellostyleInfi': 
      Number(carouselIndex)===1 && item.linerow===1?'hellostyleOnce':'',
      Number(carouselIndex)===0 && item.linerow===2?'hellostyleInfitwo':
      Number(carouselIndex)===1 && item.linerow===2?'hellostyleOncetwo':'',
       Number(carouselIndex)===0 && item.linerow===3?'hellostyleInfithree':
      Number(carouselIndex)===1 && item.linerow===3?'hellostyleOncethree':'',
       Number(carouselIndex)===0 && item.linerow===4?'hellostyleInfifour':
      Number(carouselIndex)===1 && item.linerow===4?'hellostyleOncefour':'',
      Number(carouselIndex)===0 && item.linerow===5?'hellostyleInfifive':
      Number(carouselIndex)===1 && item.linerow===5?'hellostyleOncefive':'',
      Number(carouselIndex)===0 && item.linerow===6?'hellostyleInfisix':
      Number(carouselIndex)===1 && item.linerow===6?'hellostyleOncesix':'',
       Number(carouselIndex)===0 && item.linerow===7?'hellostyleInfiseven':
      Number(carouselIndex)===1 && item.linerow===7?'hellostyleOnceseven':'',
      Number(carouselIndex)===0 && item.linerow===8?'hellostyleInfieight':
      Number(carouselIndex)===1 && item.linerow===8?'hellostyleOnceeight':'',
]" v-html="item.text"></div>
      <div v-if="carouselInx==='1'" class="hellostylebuss" :style="item.style" :class="Number(carouselIndex)===0?'hellostyleInfi':'hellostyleOnceBuss'" v-html="item.text"></div>
      </div>
    </el-carousel-item>
  </el-carousel>
  </div>
</template>

<script>
export default {
  // name: 'carouselPics',
  props: {
    pics: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 0循环  1不循环
    carouselIndex: {
      type: String,
      default: 0,
    },
    // 商业视频再往上走样式
    carouselInx: {
      type: String,
      default: '0',
    }
  },
  data(){
    return{
      interval:7000,
      // carouselIndex:1
      // pics: [
      //   'https://img01.yzcdn.cn/vant/apple-1.jpg',
      //   'https://img01.yzcdn.cn/vant/apple-2.jpg',
      // ],
    }
  },
  mounted() {
    // this.$nextTick(e=>{

    //   this.$refs.carousel.forEach((item, index) => {

    //     this.$refs.carousel[index].handleMouseEnter = () => {
    //     }

    //   })

    // })
    
    // this.$refs.carousel.handleMouseEnter = () => { };
    // this.$nextTick(() => {
    //   this.delHandleMouseEnter()
    //   // 在dom渲染完后,再执行动画
    //   // const wow = new WOW({
    //   //   live: false
    //   // })
    //   // wow.init()
    //   new this.$wow.WOW({
    //     live:true
    //   }).init()
    // })
  },
  methods:{
    // // 鼠标移入卡片banner不停止
    // delHandleMouseEnter() {
    //   // console.log(111,this.$refs.carousel[index])
    //   this.$refs.carousel.handleMouseEnter = () => {
    //   }
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
*{
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    -moz-perspective: 1000;
    -ms-perspective: 1000;
    perspective: 1000;
 }
.mobile_wrap_carousel{
  /deep/ .van-swipe-item{
    overflow: hidden;
  }
  
}
.pics_each{
  width: 100%;
  height: 200px;
  // max-height: 100%;
    overflow: hidden;
    -webkit-animation:bg-scale 7s linear infinite;
    animation:bg-scale 7s linear infinite;
    backface-visibility: hidden;
}
    
@-webkit-keyframes bg-scale { 
	0%,99%{-webkit-transform:scale(1);transform:scale(1)}
	33%{-webkit-transform:scale(1.05);transform:scale(1.05)}
	66%{-webkit-transform:scale(1.1);transform:scale(1.1)}
}
@keyframes bg-scale {
	0%,99%{-webkit-transform:scale(1);transform:scale(1)}
	33%{-webkit-transform:scale(1.05);transform:scale(1.05)}
	66%{-webkit-transform:scale(1.1);transform:scale(1.1)}
}
// .wrap_pics{
//   width: 100%;
//   height: 100vh;
//   overflow: hidden;
  

  .wrap_titles{
    position:absolute;
    width: 100%;
    height: 100vh;
    left:0;
    top: 0;

  }
  

  
  /deep/ .el-carousel__container{
    width: 100%;
    height: 200px;
  }
//   .pics_each{
//     width: 100%;
//     min-height: 100%;
//     // max-height: 100%;
//     overflow: hidden;
//     -webkit-animation:bg-scale 7s linear infinite;
//     animation:bg-scale 7s linear infinite;
//   }
// }



    
// @-webkit-keyframes bg-scale { 
// 	0%,99%{-webkit-transform:scale(1);transform:scale(1)}
// 	33%{-webkit-transform:scale(1.05);transform:scale(1.05)}
// 	66%{-webkit-transform:scale(1.1);transform:scale(1.1)}
// }
// @keyframes bg-scale {
// 	0%,99%{-webkit-transform:scale(1);transform:scale(1)}
// 	33%{-webkit-transform:scale(1.05);transform:scale(1.05)}
// 	66%{-webkit-transform:scale(1.1);transform:scale(1.1)}
// }

// 通用-一行文字-start
.hellostyle{
    width: 100%;
    text-align: center;
    line-height: 25px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 200px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(-200px) ;
    // transform: translateY(calc((-100vh + 100px)*0.5)) ;
    transform: translateY(-80vh) ;
    position: absolute;
    bottom: 0;
  }
.hellostyleInfi{
    -webkit-animation:leftslideok 7s linear infinite;
    animation:leftslideok 7s linear infinite;
  }
   .hellostyleOnce{
    -webkit-animation:leftslideok 7s linear ;
    animation:leftslideok 7s linear ;
  }
@keyframes leftslideok{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(-80vh) ;opacity: 1;}
    }
// 通用-end


// 通用-两行文字-start
.hellostyletwo{
    width: 100%;
    text-align: center;
    line-height: 25px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 200px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(-200px) ;
    transform: translateY(-80vh) ;
    position: absolute;
    bottom: 0;
  }
.hellostyleInfitwo{
    -webkit-animation:leftslideoktwo 7s linear infinite;
    animation:leftslideoktwo 7s linear infinite;
  }
   .hellostyleOncetwo{
    -webkit-animation:leftslideoktwo 7s linear ;
    animation:leftslideoktwo 7s linear ;
  }
@keyframes leftslideoktwo{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(-80vh);opacity: 1;}
    }
// 通用-end

//buss-start
.hellostylebuss{
    width: 100%;
    text-align: center;
    line-height: 100px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 450px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(calc(((-100vh + 100px)*0.5) - 130px)) ;
    transform: translateY(-88vh) ;
    position: absolute;
    bottom: 0;
    
    
  }
  .hellostyleOnceBuss{
    -webkit-animation:leftslideokbuss 12s linear ;
    animation:leftslideokbuss 12s linear ;
  }
@keyframes leftslideokbuss{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(-88vh);opacity: 1;}
    }
//buss-end


// 第一页第一张图-start
.hellostylethree{
    width: 100%;
    text-align: center;
    line-height: 25px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 200px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(-200px) ;
    transform: translateY(-80vh) ;
    position: absolute;
    bottom: 0;
  }
.hellostyleInfithree{
    -webkit-animation:leftslideokthree 7s linear infinite;
    animation:leftslideokthree 7s linear infinite;
  }
   .hellostyleOncethree{
    -webkit-animation:leftslideokthree 7s linear ;
    animation:leftslideokthree 7s linear ;
  }
@keyframes leftslideokthree{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(-80vh);opacity: 1;}
    }
// 第一页第一张图-end




// 第一页第三张图-start
.hellostylefour{
    width: 100%;
    text-align: center;
    line-height: 25px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 200px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(-200px) ;
    transform: translateY(-80vh) ;
    position: absolute;
    bottom: 0;
  }
.hellostyleInfifour{
    -webkit-animation:leftslideokfour 7s linear infinite;
    animation:leftslideokfour 7s linear infinite;
  }
   .hellostyleOncefour{
    -webkit-animation:leftslideokfour 7s linear ;
    animation:leftslideokfour 7s linear ;
  }
@keyframes leftslideokfour{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(-80vh);opacity: 1;}
    }
// 第一页第三张图-end



// 第二页1,2张图-start
.hellostylefive{
    width: 100%;
    text-align: center;
    line-height: 100px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 200px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(-200px) ;
    transform: translateY(calc(((-100vh + 100px)*0.5) - 200px)) ;
    position: absolute;
    bottom: 0;
  }
.hellostyleInfifive{
    -webkit-animation:leftslideokfive 7s linear infinite;
    animation:leftslideokfive 7s linear infinite;
  }
   .hellostyleOncefive{
    -webkit-animation:leftslideokfive 7s linear ;
    animation:leftslideokfive 7s linear ;
  }
@keyframes leftslideokfive{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(calc(((-100vh + 100px)*0.5) - 200px));opacity: 1;}
    }
// 第二页1,2张图-end


// 课程视频-start
.hellostylesix{
    width: 100%;
    text-align: center;
    line-height: 100px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 200px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(-200px) ;
    // transform: translateY(calc(((-100vh + 100px)*0.3) )) ;
    transform: translateY(-70vh) ;
    position: absolute;
    bottom: 0;
  }
.hellostyleInfisix{
    -webkit-animation:leftslideoksix 7s linear infinite;
    animation:leftslideoksix 7s linear infinite;
  }
   .hellostyleOncesix{
    -webkit-animation:leftslideoksix 7s linear ;
    animation:leftslideoksix 7s linear ;
  }
@keyframes leftslideoksix{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(-70vh);opacity: 1;}
    }
// 课程视频-end



// 多媒体展示-start
.hellostyleseven{
    width: 100%;
    text-align: center;
    line-height: 100px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 200px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(-200px) ;
    // transform: translateY(calc(((-100vh + 100px)*0.7) )) ;
    transform: translateY(-70vh) ;
    position: absolute;
    bottom: 0;
  }
.hellostyleInfiseven{
    -webkit-animation:leftslideokseven 7s linear infinite;
    animation:leftslideokseven 7s linear infinite;
  }
   .hellostyleOnceseven{
    -webkit-animation:leftslideokseven 7s linear ;
    animation:leftslideokseven 7s linear ;
  }
@keyframes leftslideokseven{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(-70vh) ;opacity: 1;}
    }
// 多媒体展示-end



// 关于我们-start
.hellostyleeight{
    width: 100%;
    text-align: center;
    line-height: 100px;
    // margin-left: 200px;
    // position: absolute;
    font-size: 16px;
    // margin-top: calc((-100vh + 200px)*0.5) ;
    // background:green;
    // left: 0px;
    // bottom: 0px;
    
    // transform: translateY(-200px) ;
    // transform: translateY(calc(((-100vh + 100px)*0.8) )) ;
    transform: translateY(calc(-85vh)) ;
    position: absolute;
    bottom: 0;
  }
.hellostyleInfieight{
    -webkit-animation:leftslideokeight 12s linear infinite;
    animation:leftslideokeight 12s linear infinite;
  }
   .hellostyleOnceeight{
    -webkit-animation:leftslideokeight 12s linear ;
    animation:leftslideokeight 12s linear ;
  }
@keyframes leftslideokeight{
      0%{ transform: translateY(0px)  ;opacity: 0.5;}
      20%{transform: translateY(calc(-85vh)) ;opacity: 1;}
    }
// 关于我们-end
</style>



